import { render, staticRenderFns } from "./SurrogateNameSelection.vue?vue&type=template&id=e2772310&"
import script from "./SurrogateNameSelection.vue?vue&type=script&lang=js&"
export * from "./SurrogateNameSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports